module.exports = __webpack_public_path__ + "img/body-mass-index.19c77576.png";